import { useNavigate } from '@tanstack/react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type CreateJobInput } from '@ats/shared'
import { jobsApi } from '@/lib/api'
import { PageLayout } from '@/components/layout/PageLayout'
import { JobForm } from '@/components/features/jobs/JobForm'
import { toast } from '@/components/ui/toaster'

export function NewJobPage() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const createJob = useMutation({
    mutationFn: (data: CreateJobInput) => jobsApi.create(data),
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] })
      toast({ title: 'Job created successfully', variant: 'success' })
      navigate({ to: `/jobs/${data.id}` })
    },
    onError: (err) => {
      toast({
        title: 'Failed to create job',
        description: err instanceof Error ? err.message : 'Something went wrong',
        variant: 'destructive',
      })
    },
  })

  const handleSubmit = async (data: CreateJobInput) => {
    await createJob.mutateAsync(data)
  }

  return (
    <PageLayout fullHeight back="/jobs" title="Create New Job">
      <JobForm
        onSubmit={handleSubmit}
        isLoading={createJob.isPending}
        submitLabel="Create Job"
      />
    </PageLayout>
  )
}
